import { Loader } from "@googlemaps/js-api-loader";

import "./index.css";

export function setupMapArea() {
  const container = document.querySelector<HTMLElement>(".container-map-area");

  if (!container) {
    return;
  }

  const mapFrame = document.getElementById("map-area");
  const centerData = mapFrame?.getAttribute("data-center");

  if (!mapFrame || !centerData) {
    return;
  }

  const center: google.maps.LatLngLiteral = JSON.parse(centerData);

  const loader = new Loader({
    apiKey: import.meta.env.VITE_GOOGLE_MAP_KEY as string,
    version: "weekly",
  });

  const mapOptions: google.maps.MapOptions = {
    center,
    zoom: 15,
    disableDefaultUI: true,
  };

  let map: google.maps.Map | null = null;

  // Add center marker
  const addCenterMarker = () => {
    new google.maps.Marker({
      position: center,
      map,
      icon: {
        url: "/static/images/house-icon-pc.png",
        scaledSize: new google.maps.Size(40, 40),
        anchor: new google.maps.Point(20, 40),
      },
    });
  };

  // Initialize map
  const loadMap = () => {
    if (map) return;

    loader.load().then(() => {
      map = new google.maps.Map(mapFrame, mapOptions);
      addCenterMarker();
    });
  };

  // Lazy load map
  const observer = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting) {
        loadMap();
        observer.disconnect();
      }
    },
    { root: null, threshold: 0.1 }
  );

  observer.observe(mapFrame);
}
